<div class="unknown-element">
    <p>
        Unknown element: <strong>{{ element.type }}</strong>
    </p>
</div>
